export interface ChangeRequestHistoryEntry {
  Id: number;
  RequesterName: string;
  DateRequested: string;
  LastModifiedDate: string;
  RequestType: string;
  CompletedBy: string;
  Approved: boolean;
  Pending: boolean;
  PersonId: number;
  ClientCode: string;
}

export interface ChangeRequestData<T> {
  Old: T;
  New: T;
  Comment: string;
}

export interface RequestData<T> {
  RequestData: T;
  PrevRequestData: T;
}

export interface AddressChangeRequest {
  StreetAddress: string;
  StreetAddress2: string;
  City: string;
  State: string;
  PostalCode: string;
  Country: string;
  IsNonUsAddress: boolean;
}

export interface DirectDepositRequest {
  Disabled: AccountDisable[];
  New: AccountAdd[];
  AllocationChange: AllocationChange[];
}

export interface AccountAdd {
  BankName: string;
  RoutingNumber: string;
  AccountNumber: string;
  AccountType: number;
  CalculationMethod: number;
  Amount: number;
}

export interface AccountDisable {
  Id: number;
  BankName: string;
  RoutingNumber: string;
  AccountNumber: string;
  AccountType: number;
  CalculationMethod: number;
  Amount: number;
}

export interface AllocationChange {
  Id: number;
  BankName: string;
  RoutingNumber: string;
  AccountNumber: string;
  CalculationMethod: number;
  OldCalculationMethod: number;
  Amount: number;
  OldAmount: number;
  AccountType: number;
}

export enum AERequestStatusType {
  Open = 1,
  Closed = 2
}

export enum RequestType {
  AddressChange = 0,
  DirectDepositChange = 1
}
